import type { FileTree } from "api";
import type { FC } from "react";
import { useLoaderData } from "react-router-dom";

import { useUnpausedForkStatus } from "../context";
import Directory from "./Directory";

const ArtifactsRoute: FC = () => {
  const { executionId } = useUnpausedForkStatus();
  const tree = useLoaderData() as FileTree;
  return (
    <div className="flex flex-col rounded-xl bg-background p-4">
      <h3>Artifacts</h3>
      <Directory executionId={executionId} {...tree} />
    </div>
  );
};

export default ArtifactsRoute;
